module.exports = __webpack_public_path__ + "d0211e0cb057b0d50ec87fdb9871b7ca.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/whatsApp.svg
// module id = ./app/images/whatsApp.svg
// module chunks = 40